import React, { FC } from 'react'
import Carousel from 'components/SA/Carousel/v2'
import styles from './artistProfile.module.scss'
import { useSelector } from 'react-redux'
import { getFeaturedCollections } from '../selectors'
import SALink from 'components/SALink'
import { capitalizeString } from 'lib/helpers'
import useQA from 'hooks/useQA'
import { displayEllipticalString } from '../helpers'

const MAX_LENGTH = 65

const FeaturedCollections: FC = () => {
  const collections = useSelector(getFeaturedCollections)
  const { testId } = useQA()

  if (!collections.length) {
    return null
  }

  return (
    <div className={styles.featuredCollections} {...testId('featured-curated-collections')}>
      <Carousel title='Featured In Curated Collections'>
        {collections.map(({ title, collectionUrl, artworkImage }, index) => (
          <div key={index} className={styles.carouselItemWrapper}>
            <SALink href={collectionUrl} title={capitalizeString(title)}>
              <div
                key={index}
                className={styles.carouselItem}
                {...testId('featured-carousel-item')}
              >
                <img src={artworkImage} className={styles.carouselImage} />
                <p className={styles.title} {...testId('title')}>
                  {displayEllipticalString(capitalizeString(title), MAX_LENGTH)}
                </p>
              </div>
            </SALink>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default FeaturedCollections
